<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.divisionNumber" clearable placeholder="车间编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.divisionName" clearable placeholder="车间名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="divisionNumber" label="车间编码" width="140" />
      <el-table-column prop="divisionName" label="车间名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="factoryName" label="工厂" width="120" show-overflow-tooltip />
      <el-table-column prop="componentsLocationName" label="组件仓" min-width="120" show-overflow-tooltip />
      <el-table-column prop="intermediateLocationName" label="半成品仓" min-width="120" show-overflow-tooltip />
      <el-table-column prop="productsInputLocationName" label="成品入库仓" min-width="120" show-overflow-tooltip />
      <el-table-column prop="subcontractLocationName" label="外协发料仓" min-width="120" show-overflow-tooltip />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.divisionId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.divisionId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.divisionId ? '修改车间' : '新增车间'" :visible.sync="visible" width="620px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="车间编码" prop="divisionNumber">
          <el-input v-model="form.divisionNumber" />
        </el-form-item>
        <el-form-item label="车间名称" prop="divisionName">
          <el-input v-model="form.divisionName" />
        </el-form-item>
        <el-form-item label="工厂">
          <el-select v-model="form.factoryId" clearable filterable style="width:100%">
            <el-option v-for="i in factoryOptions" :key="i.factoryId" :label="i.factoryName" :value="i.factoryId" />
          </el-select>
        </el-form-item>
        <el-form-item label="工作日历">
          <el-select v-model="form.calendarId" clearable filterable placeholder="空则继承工厂" style="width:100%">
            <el-option
              v-for="i in calendarOptions"
              :key="i.calendarId"
              :label="(i.calendarNumber || '') + ' ' + (i.calendarName || '')"
              :value="i.calendarId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="组件仓">
          <el-select v-model="form.componentsLocationId" clearable filterable placeholder="报工投入扣料仓" style="width:100%">
            <el-option v-for="i in warehouseOptions" :key="i.wareHouseId" :label="i.wareHouseName" :value="i.wareHouseId" />
          </el-select>
        </el-form-item>
        <el-form-item label="半成品仓">
          <el-select v-model="form.intermediateLocationId" clearable filterable placeholder="半成品报工入库仓" style="width:100%">
            <el-option v-for="i in warehouseOptions" :key="'m-' + i.wareHouseId" :label="i.wareHouseName" :value="i.wareHouseId" />
          </el-select>
        </el-form-item>
        <el-form-item label="成品入库仓">
          <el-select v-model="form.productsInputLocationId" clearable filterable placeholder="成品报工入库仓" style="width:100%">
            <el-option v-for="i in warehouseOptions" :key="'p-' + i.wareHouseId" :label="i.wareHouseName" :value="i.wareHouseId" />
          </el-select>
        </el-form-item>
        <el-form-item label="外协发料仓">
          <el-select v-model="form.subcontractLocationId" clearable filterable placeholder="外协下达默认移入仓" style="width:100%">
            <el-option v-for="i in warehouseOptions" :key="'s-' + i.wareHouseId" :label="i.wareHouseName" :value="i.wareHouseId" />
          </el-select>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.comment" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listDivision, getDivision, saveDivision, updateDivision, deleteDivision } from '../../api/division'
import { selectFactory, selectWorkCalendar } from '../../api/factory'
import { selectEnabledWareHouse } from '../../api/warehouse'

function emptyForm() {
  return {
    divisionId: '',
    divisionNumber: '',
    divisionName: '',
    factoryId: '',
    calendarId: '',
    componentsLocationId: '',
    productsInputLocationId: '',
    intermediateLocationId: '',
    subcontractLocationId: '',
    active: '1',
    comment: ''
  }
}

export default {
  name: 'MesDivisionPage',
  components: { ListPagination },
  data() {
    return {
      query: { divisionNumber: '', divisionName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      factoryOptions: [],
      calendarOptions: [],
      warehouseOptions: [],
      form: emptyForm(),
      rules: {
        divisionNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        divisionName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listDivision({
        currentPage: this.page,
        pageSize: this.pageSize,
        divisionNumber: this.query.divisionNumber,
        divisionName: this.query.divisionName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      selectFactory().then(res => { this.factoryOptions = res.data || [] }).catch(() => { this.factoryOptions = [] })
      selectWorkCalendar().then(res => { this.calendarOptions = res.data || [] }).catch(() => { this.calendarOptions = [] })
      selectEnabledWareHouse().then(res => { this.warehouseOptions = res.data || [] }).catch(() => { this.warehouseOptions = [] })
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getDivision(id).then(res => {
        this.form = Object.assign(emptyForm(), res.data || {})
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const payload = Object.assign({}, this.form)
        const req = payload.divisionId ? updateDivision(payload) : saveDivision(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.divisionId)
      if (!ids.length) return
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteDivision(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
